import {useState} from 'react';
import {Search} from 'lucide-react';
import {useRadarLocale} from '@/i18n/RadarLocaleContext';
import type {BriefVersion} from './types';
import '@/styles/radar-brief-email.css';

export function RadarBriefHistory({versions,currentRevision,onEdit,onResults,onSearch,busy=false}: {
 versions:BriefVersion[];currentRevision?:number;busy?:boolean;
 onEdit:(version:BriefVersion)=>void;onResults:(version:number)=>void;onSearch:(version:number)=>void;
}) {
 const {t,locale}=useRadarLocale();
 const [selected,setSelected]=useState<number>();
 const version=versions.find(v=>v.version===selected)||versions[0];
 if(!version)return null;
 const brief=version.brief;
 return <section className="radar-brief-history" aria-label={t('Market brief versions')}>
  <nav aria-label={t('Versions')}><h2>{t('Versions')}</h2>{versions.map(v=><button key={v.version}
   aria-pressed={v.version===version.version} disabled={busy} onClick={()=>setSelected(v.version)}>
   <strong>v{v.version}{v.revision===currentRevision&&<span> · {t('Current')}</span>}</strong>
   <small>{v.created_at?new Date(v.created_at).toLocaleDateString(locale):t('Earlier saved brief')}</small>
  </button>)}</nav>
  <article className="radar-workspace-panel">
   <header><div><span className="radar-workspace-eyebrow">{t('Market brief')}</span><h1>{brief.target_market} <span className="radar-brief-version">v{version.version}</span></h1></div>
    {version.revision===currentRevision&&<span className="radar-current-brief">{t('Currently in use')}</span>}</header>
   <dl>{[
    ['Your offer',brief.seller_summary],['Products',brief.products?.join(' · ')],
    ['Target customers',brief.target_account_types?.join(' · ')],['Relationship goal',brief.relationship_goal],
    ['Required capabilities',brief.required_capabilities?.join(' · ')],['Exclusions',brief.exclusions?.join(' · ')],
   ].filter(([,value])=>!!value).map(([label,value])=><div key={label}><dt>{t(label)}</dt><dd>{value}</dd></div>)}</dl>
   <footer><button className="radar-secondary-action" disabled={busy} onClick={()=>onEdit(version)}>{t('Edit from this version')}</button>
    <div><button className="radar-text-button" disabled={busy} onClick={()=>onResults(version.version)}>{t('View results')}</button>
    <button className="radar-primary-action" disabled={busy} onClick={()=>onSearch(version.version)}><Search size={16}/>{t('Search with v{version}',{version:version.version})}</button></div></footer>
  </article>
 </section>;
}
